import type { ReactNode } from "react";

interface FooterColumnProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export default function FooterColumn({
  title,
  children,
  className,
}: FooterColumnProps) {
  return (
    <div className={className}>
      <h3 className="mb-6 text-sm font-medium text-dark dark:text-white">
        {title}
      </h3>
      {children}
    </div>
  );
}
